import { PlacementsDatabaseStateModel } from "@platform-app/app/main/placements-database/shared/store/models";

export const CURRENT_PLACEMENT_DATABASE_VERSION = 1;

export const DEFAULT_PLACEMENTS_DATABASE_STATE: PlacementsDatabaseStateModel = {
  version: CURRENT_PLACEMENT_DATABASE_VERSION,

  // Organizations
  organizations: null,
  previewOrganizationId: null,
  selectedTab: null,

  // Opportunities
  opportunities: null,
  previewOpportunityId: null,
  opportunityDetailsId: null,

  // Filters
  viewport: null,
  manualFilters: {
    searchText: null,
    clinicTypesIds: null,
    schoolTypesIds: null,
    disciplinesIds: null,
    specialtiesIds: null,
    opportunityTypes: null,
    startDate: null,
    endDate: null,
  },
  locationFilters: null,
  filtersTab: null,
  filtersManuallyModified: false,
  filtersInitialized: false,

  // Listing
  pagination: { currentPage: 1, itemsPerPage: 50 },
  itemsCount: 0,
  isLoading: true,
  isListVisible: true,
  listType: null,
  databaseStatistics: null,

  // Students Smart Match
  smartMatchStudentId: null,
  smartMatchStudents: null,
  smartMatchMessageDismissedForStudents: {},

  // Schools Smart Match
  smartMatchSchools: null,
  smartMatchSchoolId: null,
  smartMatchMessageDismissedForSchools: {},
};
